import {
    orderListAdditionalListProps,
    OrderListExtendedModel,
    OrdersList as BaseOrdersList
} from '@views/orders/OrdersList';
import app from '@src/helpers/app';
import {ListViewProps} from '@src/components/_views/configurable/ListView';
import {ListProps} from '@src/@types/components/List';

const tableHeadProps: typeof orderListAdditionalListProps['head'] = {
    ...orderListAdditionalListProps['head'],
    preferenceNameMutator: (name: string) => `admin-dashboard.only-with-attentions.${name}`,
};

class OrdersList extends BaseOrdersList {
    protected getPropsForListComponent(): Partial<NonNullable<ListViewProps<OrderListExtendedModel>['listProps']>> {
        const url = app('url')
                .getRouteByName('orders.get-with-attentions')
                .resolveUrl();

        return {
            getListRequestUrl: url,
            recordsProviderAdditionalShapeProps: {is: 'orders-list-with-attentions'},
            createButton: null,
            withoutControlsRow: true,
            withoutFilters: true,
        };
    }

    protected getPropsForTableHeadComponent(): ListProps['tableHeadProps'] {
        return tableHeadProps;
    }
}

export default OrdersList.getStoreConnector()(OrdersList);
